export default [
  {
    path: '/usuarios',
    name: 'Usuario',
    component: () => import(/* webpackChunkName: "Usuario" */ '../usuarios/Usuarios')
  },
  {
    path: '/usuarios-cadastro',
    name: 'UsuariosCadastro',
    component: () => import(/* webpackChunkName: "UsuariosCadastro" */ '../usuarios/UsuariosCadastro')
  },
  {
    path: '/usuarios-lista',
    name: 'UsuariosLista',
    component: () => import(/* webpackChunkName: "UsuariosLista" */ '../usuarios/UsuariosLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/usuarios/router.js